import React from 'react'
import {injectIntl} from 'react-intl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import NumberFields from 'components/NumberFields'

class NumberFieldConfig extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            decimalSeparator:  props.config.decimalSeparator || '.',
            currencyPosition:  props.config.currencyPosition || 1,
            decimalLength: props.config.decimalLength || '',
            currencySymbol: props.config.currencySymbol || ''
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    changeType = () => {
        this.props.changeTypeToNumber({...this.state})
        this.props.onClose()
        this.props.handleCloseMenu()
    }

    render() {
        const { intl } = this.props

        return (
            <React.Fragment>
                <DialogTitle>
                    {intl.formatMessage({id: "config.number_field_title"})}
                </DialogTitle>
                <DialogContent>
                    <NumberFields
                        decimalLength={this.state.decimalLength}
                        handleChange={this.handleChange}
                        currencySymbol={this.state.currencySymbol}
                        decimalSeparator={this.state.decimalSeparator}
                        currencyPosition={this.state.currencyPosition}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    <Button onClick={this.changeType} color="primary" variant="contained">
                        {intl.formatMessage({id: "app.confirm_save"})}
                    </Button>
                </DialogActions>
            </React.Fragment>
        )
    }
}

export default (injectIntl(NumberFieldConfig))
